/**
 * plp-scripts.js — clean rewrite
 * Filter drawer (bottom-sheet) + AJAX section re-render + variant modal + ATC
 */
(function () {
  'use strict';

  /* ── Utilities ── */
  function formatMoney(cents) {
    try {
      const code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency: code, currencyDisplay: 'symbol',
        minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch { return '₹' + (cents / 100).toFixed(0); }
  }

  /* ── Cart helpers ── */
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  async function cartAdd(variantId) {
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  }

  async function refreshCart(countEl) {
    try {
      const res  = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      if (countEl) countEl.textContent = cart.item_count;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      return cart;
    } catch { return null; }
  }

  /* ── ATC button state ── */
  function setAtcState(btn, state) {
    const icon = btn.querySelector('.plp-atc-icon');
    const spin = btn.querySelector('.plp-atc-spinner');
    const chk  = btn.querySelector('.plp-atc-check');
    btn.classList.remove('is-loading', 'is-success', 'is-error');
    if (icon) icon.hidden = true;
    if (spin) spin.hidden = true;
    if (chk)  chk.hidden  = true;
    if      (state === 'loading') { btn.classList.add('is-loading'); if (spin) spin.hidden = false; }
    else if (state === 'success') { btn.classList.add('is-success'); if (chk)  chk.hidden  = false; }
    else if (state === 'error')   { btn.classList.add('is-error');   if (icon) icon.hidden  = false; }
    else                          { if (icon) icon.hidden = false; }
  }

  /* ── Toast ── */
  function showToast(toastEl, msg, isError) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.toggle('plp-toast--error', Boolean(isError));
    toastEl.classList.add('plp-toast--show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('plp-toast--show'), 2400);
  }

  /* ── Product data cache ── */
  const productCache = new Map();

  async function fetchProductData(card) {
    const handle = card.dataset.productHandle;
    if (!handle) throw new Error('no handle');
    if (productCache.has(handle)) return productCache.get(handle);
    const res = await fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('fetch failed');
    const raw = await res.json();
    const optionNames = (raw.options || []).map(o => typeof o === 'string' ? o : o.name || String(o));
    const optionsWithValues = optionNames.map((name, idx) => {
      const seen = new Set();
      (raw.variants || []).forEach(v => {
        const val = Array.isArray(v.options) && v.options[idx] != null ? v.options[idx] : v['option' + (idx + 1)];
        if (val != null) seen.add(String(val));
      });
      return { name, values: Array.from(seen) };
    });
    const product = {
      title: raw.title, url: '/products/' + raw.handle, handle: raw.handle,
      options: optionNames, optionsWithValues,
      variants: (raw.variants || []).map(v => {
        const opts = Array.isArray(v.options) && v.options.length
          ? v.options.map(o => String(o))
          : [v.option1, v.option2, v.option3].filter(o => o != null).map(o => String(o));
        return { id: v.id, title: v.title, options: opts, available: v.available,
          price: v.price, compare_at_price: v.compare_at_price,
          price_formatted: formatMoney(v.price),
          compare_at_price_fmt: v.compare_at_price ? formatMoney(v.compare_at_price) : null };
      })
    };
    productCache.set(handle, product);
    return product;
  }

  function findVariant(product, selected) {
    return product.variants.find(v => product.options.every((name, idx) => selected[name] === v.options[idx])) || null;
  }
  function isCombinationAvailable(product, selected, optName, value) {
    const trial = Object.assign({}, selected, { [optName]: value });
    return product.variants.some(v => v.available && product.options.every((name, idx) => trial[name] === v.options[idx]));
  }
  function parseUnit(label) {
    const m = String(label).match(/([\d.]+)\s*(kg|g|l|ml|lb)\b/i);
    if (!m) return null;
    let v = parseFloat(m[1]); const u = m[2].toLowerCase();
    if (u === 'kg') { v *= 1000; return { value: v, unit: 'g' }; }
    if (u === 'l')  { v *= 1000; return { value: v, unit: 'ml' }; }
    if (u === 'lb') return null;
    return { value: v, unit: u };
  }
  function isWeightOption(values) {
    let h = 0; values.forEach(v => { if (parseUnit(v)) h++; });
    return h >= Math.ceil(values.length / 2);
  }

  function buildModalOptions(wrap, product, state, onSelect) {
    const frag = document.createDocumentFragment();
    product.optionsWithValues.forEach(opt => {
      const group = document.createElement('div'); group.className = 'plp-opt-group';
      const lbl = document.createElement('div'); lbl.className = 'plp-opt-label'; lbl.textContent = opt.name;
      group.appendChild(lbl);
      const asCards = isWeightOption(opt.values);
      const grid = document.createElement('div'); grid.className = asCards ? 'plp-opt-cards' : 'plp-opt-pills';
      opt.values.forEach(value => {
        const isSel   = state.selected[opt.name] === value;
        const isAvail = isCombinationAvailable(product, state.selected, opt.name, value);
        const trial   = Object.assign({}, state.selected, { [opt.name]: value });
        const prev    = findVariant(product, trial) || product.variants.find(v => v.options[product.options.indexOf(opt.name)] === value);
        if (asCards) {
          const btn = document.createElement('button'); btn.type = 'button';
          btn.className = 'plp-opt-card' + (isSel ? ' is-selected' : '') + (!isAvail ? ' is-unavailable' : '');
          btn.disabled = !isAvail;
          const nm = document.createElement('div'); nm.className = 'plp-opt-card__name'; nm.textContent = value; btn.appendChild(nm);
          if (prev) {
            const pr = document.createElement('div'); pr.className = 'plp-opt-card__price'; pr.textContent = prev.price_formatted; btn.appendChild(pr);
            if (prev.compare_at_price > prev.price) {
              const pct = Math.round((prev.compare_at_price - prev.price) / prev.compare_at_price * 100);
              const bw = document.createElement('div'); bw.className = 'plp-opt-card__badge'; bw.textContent = pct + '% Off'; btn.appendChild(bw);
            }
          }
          btn.addEventListener('click', () => { if (!isAvail) return; state.selected[opt.name] = value; onSelect(); });
          grid.appendChild(btn);
        } else {
          const pill = document.createElement('button'); pill.type = 'button';
          pill.className = 'plp-opt-pill' + (isSel ? ' is-selected' : '') + (!isAvail ? ' is-unavailable' : '');
          pill.disabled = !isAvail; pill.textContent = value;
          pill.addEventListener('click', () => { if (!isAvail) return; state.selected[opt.name] = value; onSelect(); });
          grid.appendChild(pill);
        }
      });
      group.appendChild(grid); frag.appendChild(group);
    });
    wrap.replaceChildren(frag);
  }

  /* ════════════════════════════════════════════════
     FILTER PARAMS — reads all active filter forms and merges them.
     Price is now a radio input (filter.v.price.lte) — treated like
     any other filter input, no special-casing needed.
  ════════════════════════════════════════════════ */
  function buildFilterParams() {
    const params = new URLSearchParams();

    const forms = Array.from(document.querySelectorAll('[data-plp-filter-form]'));
    if (!forms.length) return params;

    // Deduplicate across forms (drawer + sidebar may both exist on desktop).
    const seen = new Set();

    for (const form of forms) {
      new FormData(form).forEach((val, key) => {
        if (val === '') return;
        const dedupeKey = key + '=' + val;
        if (seen.has(dedupeKey)) return;
        seen.add(dedupeKey);
        params.append(key, val);
      });
    }

    params.delete('page');
    return params;
  }

  /* ════════════════════════════════════════════════
     AJAX SECTION RE-RENDER
     Only swaps [data-plp-renderable] — drawer/modal/toast survive.
  ════════════════════════════════════════════════ */
  const VALID_SORTS = ['manual','best-selling','title-ascending','title-descending',
                       'price-ascending','price-descending','created-descending','created-ascending'];
  let renderInFlight = false;

  async function renderSection(params) {
    if (renderInFlight) return;
    renderInFlight = true;

    const wrapper = document.querySelector('[data-section-id]');
    if (!wrapper) { renderInFlight = false; return; }
    const sectionId = wrapper.dataset.sectionId;

    // Sanitise sort_by
    const sortVal = params.get('sort_by');
    if (sortVal && !VALID_SORTS.includes(sortVal)) params.delete('sort_by');

    const prevUrl = window.location.href;

    const url = new URL(window.location.href);
    url.search = '';
    params.forEach((val, key) => url.searchParams.append(key, val));
    history.pushState({ plpFilters: params.toString() }, '', url.toString());

    const grid = document.getElementById('PlpGrid');
    if (grid) grid.classList.add('plp-grid--loading');

    try {
      const fetchUrl = new URL(url.toString());
      fetchUrl.searchParams.set('sections', sectionId);
      const res = await fetch(fetchUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error('Section fetch ' + res.status);

      const json = await res.json();
      const html = json[sectionId];
      if (!html) throw new Error('No section HTML in response');

      const doc = new DOMParser().parseFromString(html, 'text/html');

      // ONE swap: replace .plp-content (grid + pagination).
      // Controls bar and active pills are swapped separately.
      // Drawer, modal, toast are NEVER touched.
      const newContent = doc.querySelector('.plp-content');
      const curContent = document.querySelector('.plp-content');
      if (newContent && curContent) curContent.replaceWith(newContent);

      // Swap sidebar (desktop accordion — lives outside .plp-content)
      const newSidebar = doc.querySelector('.plp-sidebar');
      const curSidebar = document.querySelector('.plp-sidebar');
      if (newSidebar && curSidebar) curSidebar.replaceWith(newSidebar);

      // Swap controls bar (product count + sort select)
      const newControls = doc.querySelector('.plp-controls');
      const curControls = document.querySelector('.plp-controls');
      if (newControls && curControls) curControls.replaceWith(newControls);

      // Swap active filter pills (may appear/disappear)
      const newPills = doc.querySelector('.plp-active-filters');
      const curPills = document.querySelector('.plp-active-filters');
      if (newPills && curPills)       curPills.replaceWith(newPills);
      else if (!newPills && curPills) curPills.remove();
      else if (newPills && !curPills) {
        const ref = document.querySelector('.plp-layout') || document.querySelector('.plp-controls');
        if (ref) ref.insertAdjacentElement('beforebegin', newPills);
      }

      // Re-init only listeners on newly inserted DOM nodes.
      // Drawer listeners are NOT re-attached (drawer was not swapped).
      initSortSelect();        // sort select is inside controls (swapped)
      initActiveFilterPills(); // pills are swapped
      initGridDelegation();    // grid is swapped
      initFilterListeners();   // sidebar checkboxes are inside plp-content (swapped)
      initSidebarPriceSliders(); // sidebar price range is inside plp-content (swapped)
      initFilterSearch();      // brand search bar is inside sidebar (swapped)

    } catch (err) {
      console.error('[plp] renderSection failed:', err);
      history.replaceState({}, '', prevUrl); // restore URL, don't navigate away
    } finally {
      renderInFlight = false;
      document.body.style.overflow = '';
      const g = document.getElementById('PlpGrid');
      if (g) g.classList.remove('plp-grid--loading');
    }
  }

  function renderByURL(href) {
    const url = new URL(href, window.location.origin);
    const params = url.searchParams;
    params.delete('page');
    renderSection(params);
  }

  /* ════════════════════════════════════════════════
     FILTER LISTENERS (sidebar/bar only — drawer waits for Apply)
  ════════════════════════════════════════════════ */
  function initFilterListeners() {
    document.querySelectorAll('[data-plp-filter-input]').forEach(input => {
      input.addEventListener('change', () => {
        if (input.closest('#PlpFiltersForm--drawer')) return; // drawer waits for Apply
        renderSection(buildFilterParams());
      });
    });
  }

  /* ── Price range sliders — REMOVED (replaced by fixed price buckets) ── */
  function initPriceRangeSliders() { /* no-op */ }
  function initSidebarPriceSliders() { /* no-op */ }

  /* ── Filter search (brand search bar) ── */
  function initFilterSearch() {
    // Use event delegation so it works after sidebar re-renders and inside the persistent drawer.
    document.querySelectorAll('[data-plp-filter-search]').forEach(input => {
      if (input._plpSearchInit) return;
      input._plpSearchInit = true;
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        // Walk up to find the options container, then filter labels within it.
        const container = input.closest('.plp-filter-options, .plp-f2col__pane');
        if (!container) return;
        container.querySelectorAll('.plp-filter-checkbox, .plp-fv-checkbox').forEach(label => {
          const text = (label.querySelector('.plp-filter-checkbox__label, .plp-fv-checkbox__label')
            ?.textContent || '').toLowerCase();
          label.style.display = (!query || text.includes(query)) ? '' : 'none';
        });
      });
    });
  }

  /* ── Sort select ── */
  function initSortSelect() {
    const sel = document.getElementById('PlpSortSelect');
    if (!sel) return;
    sel.addEventListener('change', () => {
      document.querySelectorAll('[data-plp-filter-form] input[name="sort_by"]').forEach(i => { i.value = sel.value; });
      renderSection(buildFilterParams());
    });
  }

  /* ── Active filter pills ── */
  function initActiveFilterPills() {
    document.querySelectorAll('.plp-active-filter-pill, .plp-clear-all').forEach(link => {
      link.addEventListener('click', e => { e.preventDefault(); renderByURL(link.href); });
    });
  }

  /* ── Filter tabs (two-column layout) ── */
  function initFilterTabs() {
    document.querySelectorAll('[data-plp-filter-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        const pane = document.getElementById(tab.getAttribute('aria-controls'));
        if (!pane) return;
        const rail = tab.closest('.plp-f2col__rail');
        if (rail) rail.querySelectorAll('[data-plp-filter-tab]').forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        const panes = pane.closest('.plp-f2col__panes');
        if (panes) panes.querySelectorAll('[data-plp-filter-pane]').forEach(p => p.classList.remove('is-active'));
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        pane.classList.add('is-active');
      });
    });
  }

  /* ════════════════════════════════════════════════
     FILTER DRAWER — runs ONCE at boot, drawer DOM persists
  ════════════════════════════════════════════════ */
  function initFilterDrawer() {
    const drawer  = document.getElementById('PlpFilterDrawer');
    const overlay = document.getElementById('PlpFilterDrawerOverlay');
    const apply   = document.getElementById('PlpFilterDrawerApply');
    const clearLk = document.getElementById('PlpFilterDrawerClearLink');

    if (!drawer) return;

    const drawerForm = document.getElementById('PlpFiltersForm--drawer');

    // Sync drawer radio/checkbox state from current URL params each time it opens.
    // Needed because the drawer DOM is never re-rendered — desktop filter changes
    // update the URL but leave the drawer stale.
    function syncDrawerFromURL() {
      if (!drawerForm) return;
      const urlParams = new URLSearchParams(window.location.search);

      drawerForm.querySelectorAll('[data-plp-filter-input]').forEach(input => {
        const urlValues = urlParams.getAll(input.name);
        if (input.type === 'radio') {
          // Check if this radio's value matches any URL value for this param name
          input.checked = urlValues.includes(input.value);
        } else if (input.type === 'checkbox') {
          input.checked = urlValues.includes(input.value);
        }
      });
    }

    const open  = () => {
      syncDrawerFromURL();
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const close = () => { drawer.setAttribute('aria-hidden', 'true');  document.body.style.overflow = ''; };

    // Use delegation on document for the toggle button — it lives inside .plp-controls
    // which gets swapped on re-render, so a direct listener would die.
    document.addEventListener('click', e => {
      if (e.target.closest('#PlpFilterToggle')) open();
    });

    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    if (apply) {
      apply.addEventListener('click', () => {
        const params = buildFilterParams(); // read BEFORE close()
        close();
        renderSection(params);
      });
    }

    if (clearLk) {
      clearLk.addEventListener('click', e => {
        e.preventDefault();
        close();
        renderByURL(clearLk.href);
      });
    }

    initFilterTabs();
  }

  /* ════════════════════════════════════════════════
     GRID — ATC + VARIANT MODAL (re-attached after each re-render)
  ════════════════════════════════════════════════ */
  function initGridDelegation() {
    const wrapper = document.querySelector('[data-section-id]');
    if (!wrapper) return;
    const sid = wrapper.dataset.sectionId;

    const toastEl    = document.getElementById('plp-toast-' + sid);
    const overlay    = document.getElementById('plp-modal-overlay-' + sid);
    const modalClose = document.getElementById('plp-modal-close-' + sid);
    const modalLink  = document.getElementById('plp-modal-link-' + sid);
    const modalImg   = document.getElementById('plp-modal-img-' + sid);
    const modalTitleEl = document.getElementById('plp-modal-title-' + sid);
    const modalOpts  = document.getElementById('plp-modal-options-' + sid);
    const modalAddBtn = document.getElementById('plp-modal-add-' + sid);
    const modalAddLbl = document.getElementById('plp-modal-add-label-' + sid);
    const modalAddSpn = modalAddBtn ? modalAddBtn.querySelector('.plp-modal__add-spinner') : null;
    const modalCartCt = document.getElementById('plp-modal-cart-count-' + sid);
    let modalState = null;

    function refreshModal(product) {
      modalState.matchedVariant = findVariant(product, modalState.selected);
      buildModalOptions(modalOpts, product, modalState, () => refreshModal(product));
      const allSel = product.options.every(n => modalState.selected[n]);
      const v = modalState.matchedVariant;
      if (modalAddBtn) modalAddBtn.disabled = !(allSel && v && v.available);
      if (modalAddLbl) modalAddLbl.textContent = !allSel ? 'Select options' : !v ? 'Unavailable' : !v.available ? 'Sold Out' : 'Add to Cart';
    }

    async function openModal(card) {
      const quickTitle = card.querySelector('.plp-card__title a')?.textContent || '';
      const quickImg   = card.querySelector('img')?.src || '';
      if (modalLink)    modalLink.href = card.dataset.productUrl || '#';
      if (modalImg)     { modalImg.src = quickImg; modalImg.alt = quickTitle; }
      if (modalTitleEl) modalTitleEl.textContent = quickTitle;
      if (modalOpts)    modalOpts.innerHTML = '<div class="plp-modal__loading">Loading options…</div>';
      if (modalAddBtn)  { modalAddBtn.disabled = true; }
      if (modalAddLbl)  modalAddLbl.textContent = 'Loading…';
      if (overlay)      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => { if (modalClose) modalClose.focus(); }, 50);
      refreshCart(modalCartCt);
      try {
        const product = await fetchProductData(card);
        const first = product.variants.find(v => v.available) || product.variants[0];
        const selected = {};
        if (first) product.options.forEach((name, idx) => { selected[name] = first.options[idx]; });
        modalState = { product, selected, matchedVariant: first };
        if (modalLink)    modalLink.href = product.url;
        if (modalTitleEl) modalTitleEl.textContent = product.title;
        refreshModal(product);
      } catch { if (modalOpts) modalOpts.innerHTML = '<div class="plp-modal__loading">Couldn\'t load options.</div>'; }
    }

    function closeModal() {
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      modalState = null;
    }

    if (overlay) {
      if (modalClose) modalClose.addEventListener('click', closeModal);
      overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closeModal(); });
    }

    if (modalAddBtn) {
      modalAddBtn.addEventListener('click', async () => {
        if (!modalState?.matchedVariant || modalAddBtn.disabled) return;
        const vid = modalState.matchedVariant.id;
        modalAddBtn.classList.add('is-loading'); modalAddBtn.disabled = true;
        if (modalAddSpn) modalAddSpn.hidden = false;
        try {
          const data = await cartAdd(vid);
          refreshCart(modalCartCt);
          showToast(toastEl, (data.items[0].title || 'Item') + ' added to cart');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          setTimeout(() => document.dispatchEvent(new CustomEvent('cart:open-drawer', { bubbles: true })), 300);
          closeModal();
        } catch (err) { showToast(toastEl, (err && err.description) || 'Could not add to cart', true); }
        finally { modalAddBtn.classList.remove('is-loading'); modalAddBtn.disabled = false; if (modalAddSpn) modalAddSpn.hidden = true; }
      });
    }

    const grid = document.getElementById('PlpGrid');
    if (grid) {
      grid.addEventListener('click', e => {
        const atcBtn = e.target.closest('[data-plp-atc]');
        const varSel = e.target.closest('[data-plp-variant-selector]');
        const trigger = atcBtn || varSel;
        if (!trigger) return;
        const card = trigger.closest('[data-plp-card]');
        if (!card) return;
        e.preventDefault();
        if (parseInt(card.dataset.variantCount || '1', 10) > 1) { openModal(card); return; }
        if (!atcBtn) return;
        const vid = card.dataset.variantId, avail = card.dataset.available === 'true';
        if (!vid || !avail) { showToast(toastEl, 'This product is unavailable', true); setAtcState(atcBtn, 'error'); setTimeout(() => setAtcState(atcBtn, 'idle'), 1600); return; }
        setAtcState(atcBtn, 'loading'); atcBtn.setAttribute('data-disabled', 'true');
        cartAdd(vid)
          .then(data => { refreshCart(null); showToast(toastEl, (data.items[0].title || 'Item') + ' added to cart'); setAtcState(atcBtn, 'success');
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            setTimeout(() => { setAtcState(atcBtn, 'idle'); document.dispatchEvent(new CustomEvent('cart:open-drawer', { bubbles: true })); }, 1500); })
          .catch(err => { showToast(toastEl, (err && err.description) || 'Could not add to cart', true); setAtcState(atcBtn, 'error'); setTimeout(() => setAtcState(atcBtn, 'idle'), 1800); })
          .finally(() => atcBtn.removeAttribute('data-disabled'));
      });
      grid.addEventListener('keydown', e => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const t = e.target.closest('[data-plp-atc],[data-plp-variant-selector]');
        if (t) { e.preventDefault(); t.click(); }
      });
    }
  }

  /* ════════════════════════════════════════════════
     BOOT
  ════════════════════════════════════════════════ */
  window.addEventListener('popstate', () => window.location.reload());

  function boot() {
    initFilterDrawer();        // once — drawer DOM persists across re-renders
    initFilterListeners();     // sidebar/bar checkbox inputs
    initPriceRangeSliders();   // no-op
    initSidebarPriceSliders(); // no-op
    initSortSelect();
    initActiveFilterPills();
    initGridDelegation();
    initFilterSearch();        // brand search bar
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);

})();
